export default __webpack_public_path__ + "images/fd20ff4cdcb3c548f3f01497806c3fee.svg";